// extracted by mini-css-extract-plugin
export default {"mainContainer":"App_mainContainer__ale26"};